var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMunicipal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5V21.5C3 21.7761 3.22386 22 3.5 22H4.79289C4.9255 22 5.05268 21.9473 5.14645 21.8536L6.85355 20.1464C6.94732 20.0527 7.0745 20 7.20711 20H8.5C8.77614 20 9 19.7761 9 19.5V13.5C9 13.2239 8.77614 13 8.5 13H3.5C3.22386 13 3 13.2239 3 13.5Z",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.5V21.5C23 21.7761 22.7761 22 22.5 22H21.2071C21.0745 22 20.9473 21.9473 20.8536 21.8536L19.1464 20.1464C19.0527 20.0527 18.9255 20 18.7929 20H17.5C17.2239 20 17 19.7761 17 19.5V13.5C17 13.2239 17.2239 13 17.5 13H22.5C22.7761 13 23 13.2239 23 13.5Z",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5V19.5732C10 19.8493 10.2239 20.0732 10.5 20.0732H11C11.2761 20.0732 11.5 19.8493 11.5 19.5732V11.5M10 11.5H11.5M10 11.5H7.06751C6.54285 11.5 6.37235 10.795 6.83903 10.5553L13 7.39024M11.5 11.5H14.5M16 11.5V19.5732C16 19.8493 15.7761 20.0732 15.5 20.0732H15C14.7239 20.0732 14.5 19.8493 14.5 19.5732V11.5M16 11.5H14.5M16 11.5H18.9325C19.4572 11.5 19.6276 10.795 19.161 10.5553L13 7.39024M13 7.39024V5.92683M13 3V3.97561M13 3.97561H16.1819C16.5558 3.97561 16.7974 4.37094 16.6269 4.70366L16.6169 4.72317C16.5435 4.86635 16.5435 5.03609 16.6169 5.17926L16.6269 5.19878C16.7974 5.5315 16.5558 5.92683 16.1819 5.92683H13M13 3.97561V5.92683M19.1207 22.1421L18.1457 21.1909C18.0523 21.0998 17.927 21.0488 17.7965 21.0488H8.2035C8.07303 21.0488 7.94773 21.0998 7.85434 21.1909L6.87934 22.1421C6.55836 22.4553 6.78007 23 7.2285 23H18.7715C19.2199 23 19.4416 22.4553 19.1207 22.1421Z",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.2778V14.5C4 14.2239 4.22386 14 4.5 14H7.5C7.77614 14 8 14.2239 8 14.5V15.2778C8 15.5539 7.77614 15.7778 7.5 15.7778H4.5C4.22386 15.7778 4 15.5539 4 15.2778Z",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14H18.5C18.2239 14 18 14.2239 18 14.5V15.2778C18 15.5539 18.2239 15.7778 18.5 15.7778H21.5C21.7761 15.7778 22 15.5539 22 15.2778V14.5C22 14.2239 21.7761 14 21.5 14Z",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.1111H18.5C18.2239 17.1111 18 17.335 18 17.6111V18.5C18 18.7761 18.2239 19 18.5 19H21.5C21.7761 19 22 18.7761 22 18.5V17.6111C22 17.335 21.7761 17.1111 21.5 17.1111Z",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.5V17.6111C4 17.335 4.22386 17.1111 4.5 17.1111H7.5C7.77614 17.1111 8 17.335 8 17.6111V18.5C8 18.7761 7.77614 19 7.5 19H4.5C4.22386 19 4 18.7761 4 18.5Z",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMunicipal);
export default __webpack_public_path__ + "static/media/Municipal.ea8559fd642c946bb8c1a4d7d5b9405c.svg";
export { ForwardRef as ReactComponent };